import { useState, useEffect } from "react";
import { getSearchRelatedProduct, IProduct } from "../server/product";
import ProductCard from "./ProductCard";

type ProductRelatedProps = {
  id: string;
};

export default function ProductRelated({ id }: ProductRelatedProps) {
  const [data, setData] = useState<IProduct[]>([]);

  useEffect(() => {
    async function load() {
      const params = {
        orderBy: null,
        orderDirection: null,
        pageIndex: 0,
        pageSize: 10,
        productId: id,
        keyword: null,
      };

      try {
        const res = await getSearchRelatedProduct(params);
        if (res) {
          setData(res);
        }
      } catch (error) {
        console.error("Error loading related products:", error);
      }
    }
    load();
  }, [id]);

  if (!data.length) return null;

  return (
    <section className="mt-10 mx-auto  ">
      <div className="mx-auto  rounded-3xl bg-white/80 p-6 shadow-lift ring-1 ring-slate-100">
        <div className="flex items-center justify-between gap-3">
          <div>
            <p className="section-eyebrow">Gợi ý thêm</p>
            <h3 className="text-lg font-bold text-slate-900">Sản phẩm liên quan</h3>
          </div>
          <span className="chip text-xs bg-slate-100 text-slate-700">
            {data.length} gợi ý
          </span>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5">
          {data?.map((item) => (
            <ProductCard key={item?.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}
